import cx from 'classnames'
import dayjs from 'dayjs'
import Styles from './SelectBrandPlanSchedule.module.scss'
import { Modal, useModals } from 'almanac-ui/Modal'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { RadioGroup, Radio } from 'components/RadioGroup'
import { RadioBullet } from 'components/RadioGroup/RadioBullet'
import { useState } from 'react'
import { BrandPlanSchedule } from 'types'
import { SelectBrandPlanScheduleProps } from './Types'
import { useOnboardingTracking } from 'hooks/useOnboardingTracking'

export const SelectBrandPlanSchedule = ({ onConfirm, schedules, onBack }: SelectBrandPlanScheduleProps) => {
  const [selectedIndex, setSelectedIndex] = useState(0)
  const { trackAddMoreContentClicked } = useOnboardingTracking()
  const { closeModal } = useModals()

  if (!schedules.length) return null

  const selectedSchedule = schedules[selectedIndex]

  const weekOfLabel = (schedule: BrandPlanSchedule) => {
    const start = dayjs(schedule.start_date)
    const end = start.add(schedule.length * 7, 'days')
    return start.month() === end.month()
      ? `${start.format('MMMM D')}-${end.format('D')}`
      : `${start.format('MMMM D')}-${end.format('MMMM D')}`
  }

  const endLabel = (index: number) => {
    if (index === 0) {
      return 'Current Week'
    }
    if (index === 1) {
      return 'Next Week'
    }

    return `Week ${index + 1}`
  }

  const handleConfirm = () => {
    if (selectedSchedule) {
      const startDate = dayjs(selectedSchedule.start_date).format('YYYY-MM-DD')
      const endDate = dayjs(selectedSchedule.start_date)
        .add(selectedSchedule.length * 7, 'days')
        .format('YYYY-MM-DD')
      trackAddMoreContentClicked(startDate, endDate)
      onConfirm(selectedSchedule)
    }
  }

  return (
    <>
      <div className={Styles.header}>
        {onBack && <Modal.BackButton onPress={onBack} />}
        <Heading level={3}>Set Schedule</Heading>
      </div>
      <Modal.Content>
        <div className={Styles.generateMyContent}>
          <Heading level={5}>When should the new content be scheduled?</Heading>
          <RadioGroup
            aria-label="Week of content"
            value={selectedIndex.toString()}
            onChange={(option) => {
              setSelectedIndex(parseInt(option))
            }}
          >
            <div className={Styles.radioOptions}>
              {schedules.map((schedule, index) => (
                <Radio key={schedule.id} value={index.toString()} hideRadio>
                  {(radioBulletProps) => (
                    <div className={cx(Styles.radioOption, { [Styles.selected]: radioBulletProps.isSelected })}>
                      <div className={Styles.left}>
                        <RadioBullet {...radioBulletProps} size={20} />
                        <Heading level={5}>{weekOfLabel(schedule)}</Heading>
                      </div>
                      <Text>{endLabel(index)}</Text>
                    </div>
                  )}
                </Radio>
              ))}
            </div>
          </RadioGroup>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton size="lg" variant="tertiary" onPress={onBack || closeModal}>
            {onBack ? 'Back' : 'Cancel'}
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton size="lg" onPress={handleConfirm} isDisabled={!selectedSchedule}>
            Add Content
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </>
  )
}
